export const autoReadSMS = (cb) => {
  const ac = new AbortController();
  async function main() {
    if ("OTPCredential" in window) {
      try {
        if (navigator.credentials) {
          try {
            await navigator.credentials
              .get({ signal: ac.signal, otp: { transport: ["sms"] } })
              .then((content) => {
                if (content && content.code) {
                  cb(content.code, ac);
                }
              })
              .catch((e) => {
                console.log(e);
              });
          } catch (e) {
            console.log(e);
            return;
          }
        }
      } catch (err) {
        console.log(err);
      }
    }
  }
  main();
};

const emailRegEx =
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

const nameRegEx = /^[a-zA-Z\s]*$/;

export const validateName = (name) => {
  nameRegEx.test(String(name).toLowerCase());
};
export const validateEmail = (email) =>
  emailRegEx.test(String(email).toLowerCase());
